var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dropdown',{attrs:{"options":[
        {
            name: 'Support',
            value: 'support',
            icon: 'headset'
        },
        {
            name: 'Submit an issue',
            value: 'issues',
            icon: 'bug',
            href: 'https://gitlab.com/volt-pm/volt-vue/issues'
        },
        {
            name: 'Lock',
            value: 'logout',
            icon: 'door-open',
            class: 'logout'
        }
    ],"anchor":"right"},on:{"input":_vm.input}},[_c('div',{staticClass:"account-avatar"},[_c('v-avatar',{attrs:{"name":_vm.username,"image":_vm.image,"size":"md"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }